import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { PaymentRequestCreateDto } from '../dtos/payment-request.dto';
import { createHttpOptions } from '../utils/http-utils';

@Injectable({
  providedIn: 'root',
})
export class PaymentRequestService {
  private http = inject(HttpClient);

  makeRequest(paymentRequest: PaymentRequestCreateDto) {
    return this.http.post(`${environment.api}PaymentRequest/create`, paymentRequest, createHttpOptions());
  }

  getPaymentById(paymentId: string) {
    return this.http.get(`${environment.api}PaymentRequest/get-by-shortid?shortId=${paymentId}`, createHttpOptions());
  }

  resendPaymentRequestEmail(shortId: string) {
    return this.http.post<string>(
      `${environment.api}PaymentRequest/resend-email?shortId=${shortId}`,
      {},
      { responseType: 'text' as 'json' },
    );
  }

  changeRequestStatus(paymentId: string, status: string) {
    const payload = `"${status}"`;
    return this.http.post(
      `${environment.api}PaymentRequest/set-status?shortId=${paymentId}`,
      payload,
      createHttpOptions(),
    );
  }

  assignToPaymentRequest(paymentRequestId: string, paymentReportId: string) {
    return this.http.post(
      `${environment.api}PaymentReport/move-to-paymentrequest?id=${paymentReportId}&shortId=${paymentRequestId}`,
      '',
      createHttpOptions(),
    );
  }
}
